<div class="container">
  <div class="row">
    <page-alert message="Pagamento Realizado com Sucesso!" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
    <page-alert [message]="paymentErrorMessage" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

    <div class="col-md-6" style="margin-top: 2rem">
      <form [formGroup]="creditCardForm" class="form-card">
        <h2>Informacoes do Cartao de Credito</h2>
        <mat-form-field appearance="outline">
          <mat-label>Nome do Titular</mat-label>
          <input matInput formControlName="holderName" />
          <mat-error *ngIf="creditCardForm.get('holderName')?.hasError('required')">Nome do titular obrigatorio</mat-error>
          <mat-error *ngIf="creditCardForm.get('holderName')?.hasError('minlength')">Informe pelo menos 3 caracteres</mat-error>
          <mat-error *ngIf="creditCardForm.get('holderName')?.hasError('pattern')">Informe apenas letras</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Numero do Cartao</mat-label>
          <input matInput type="text" inputmode="numeric" formControlName="number" mask="0000 0000 0000 0000" [dropSpecialCharacters]="true" />
          <mat-error *ngIf="creditCardForm.get('number')?.hasError('required')">Numero do cartao obrigatorio</mat-error>
          <mat-error *ngIf="creditCardForm.get('number')?.hasError('pattern')">Informe de 13 a 16 numeros</mat-error>
        </mat-form-field>

        <div class="form-row">
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Ano de Expiracao</mat-label>
              <input
                matInput
                type="text"
                inputmode="numeric"
                formControlName="expiryYear"
                mask="0000"
                [dropSpecialCharacters]="true"
                placeholder="YYYY"
              />
              <mat-error *ngIf="creditCardForm.get('expiryYear')?.hasError('required')">Ano obrigatorio</mat-error>
              <mat-error *ngIf="creditCardForm.get('expiryYear')?.hasError('pattern')">Informe 4 numeros</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Mes de Expiracao</mat-label>
              <input
                matInput
                type="text"
                inputmode="numeric"
                formControlName="expiryMonth"
                mask="00"
                [dropSpecialCharacters]="true"
                placeholder="MM"
              />
              <mat-error *ngIf="creditCardForm.get('expiryMonth')?.hasError('required')">Mes obrigatorio</mat-error>
              <mat-error *ngIf="creditCardForm.get('expiryMonth')?.hasError('pattern')">Informe um mes valido</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>CVV</mat-label>
              <input matInput type="text" inputmode="numeric" formControlName="ccv" mask="000" [dropSpecialCharacters]="true" />
              <mat-error *ngIf="creditCardForm.get('ccv')?.hasError('required')">CVV obrigatorio</mat-error>
              <mat-error *ngIf="creditCardForm.get('ccv')?.hasError('pattern')">Informe 3 numeros</mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Parcelas</mat-label>
          <input matInput type="number" min="1" max="12" formControlName="installments" />
          <mat-error *ngIf="creditCardForm.get('installments')?.hasError('required')">Parcelas obrigatorias</mat-error>
          <mat-error *ngIf="creditCardForm.get('installments')?.hasError('min') || creditCardForm.get('installments')?.hasError('max')">
            Informe de 1 a 12 parcelas
          </mat-error>
        </mat-form-field>
      </form>
    </div>

    <div class="col-md-6" style="margin-top: 2rem">
      <form [formGroup]="customerInfoForm" class="form-card">
        <h2>Informacoes do Cliente</h2>

        <div class="form-row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
              <mat-error *ngIf="customerInfoForm.get('name')?.hasError('required')">Nome obrigatorio</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" />
              <mat-error *ngIf="customerInfoForm.get('email')?.hasError('required')">Email obrigatorio</mat-error>
              <mat-error *ngIf="customerInfoForm.get('email')?.hasError('email')">Email invalido</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Tipo de Documento</mat-label>
              <mat-select formControlName="documentType">
                <mat-option selected value="CPF">CPF</mat-option>
                <mat-option value="CNPJ">CNPJ</mat-option>
              </mat-select>
              <mat-error *ngIf="customerInfoForm.get('documentType')?.hasError('required')">Tipo de documento obrigatorio</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>CPF/CNPJ</mat-label>
              <input matInput type="text" inputmode="numeric" formControlName="cpfCnpj" mask="CPF_CNPJ" [dropSpecialCharacters]="true" />
              <mat-error *ngIf="customerInfoForm.get('cpfCnpj')?.hasError('required')">Documento obrigatorio</mat-error>
            </mat-form-field>
            <div class="document-warning" *ngIf="shouldShowInvalidDocumentMessage()">{{ getInvalidDocumentMessage() }}</div>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>CEP</mat-label>
              <input matInput formControlName="postalCode" />
              <mat-error *ngIf="customerInfoForm.get('postalCode')?.hasError('required')">CEP obrigatorio</mat-error>
              <mat-error *ngIf="customerInfoForm.get('postalCode')?.hasError('pattern')">Informe 8 numeros</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Numero do Endereco</mat-label>
              <input matInput formControlName="addressNumber" />
              <mat-error *ngIf="customerInfoForm.get('addressNumber')?.hasError('required')">Numero obrigatorio</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-8">
            <mat-form-field appearance="outline">
              <mat-label>Cidade</mat-label>
              <input matInput formControlName="city" />
              <mat-error *ngIf="customerInfoForm.get('city')?.hasError('required')">Cidade obrigatoria</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>UF</mat-label>
              <input matInput maxlength="2" formControlName="state" />
              <mat-error *ngIf="customerInfoForm.get('state')?.hasError('required')">UF obrigatoria</mat-error>
              <mat-error *ngIf="customerInfoForm.get('state')?.hasError('pattern')">Informe a UF com 2 letras</mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="phone" />
          <mat-error *ngIf="customerInfoForm.get('phone')?.hasError('required')">Telefone obrigatorio</mat-error>
          <mat-error *ngIf="customerInfoForm.get('phone')?.hasError('pattern')">Informe DDD e telefone</mat-error>
        </mat-form-field>
      </form>
    </div>

    <div class="payment-submit-container">
      <button [disabled]="!canSubmitPayment()" (click)="createPayment()" class="btn-cartao" mat-flat-button color="primary">
        {{ submitted ? 'Processando...' : 'Realizar pagamento' }}
      </button>
    </div>
  </div>
</div>
